<button
  [matMenuTriggerFor]="filtermenu"
  mat-stroked-button
  [style.min-width]="isFullWidth ? '100%' : '150px'"
>
  @if (selectedBenchmark && selectedBenchmark.length > 0) {
    <span class="bench-btn-label">Select benchmark</span>
  }
  {{ selectedBenchmark ? selectedBenchmark.name_full : benchmarkPlaceholder }}
  @if (selectedBenchmark) {
    <button
      mat-icon-button
      color="primary"
      (click)="removeBenchmark(); $event.stopPropagation()"
      class="remove-benchmark-btn"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</button>
<mat-menu #filtermenu="matMenu" [overlapTrigger]="false" class="filter-menu">
  <div mat-menu-item [disableRipple]="true" style="height: 50px">
    <mat-form-field class="w-100" (click)="$event.stopPropagation()">
      <input
        placeholder="Search"
        matInput
        [(ngModel)]="searchText"
        class="select-input-search"
        (ngModelChange)="onSearchChange()"
      />
      @if (searchText != "") {
        <button
          mat-icon-button
          matSuffix
          color="primary"
          (click)="resetSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <mat-accordion class="app-nav-accordion">
    @if (indices.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header (click)="$event.stopPropagation()">
          <mat-panel-title><b>Indices</b></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion class="app-nav-accordion">
          @for (panel of indices; track panel) {
            <mat-expansion-panel>
              <mat-expansion-panel-header (click)="$event.stopPropagation()">
                <mat-panel-title>{{ panel.group }}</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                @for (f of panel.items; track f) {
                  <div
                    mat-menu-item
                    (click)="onBenchmarkSelect(f)"
                    [class.active]="
                      selectedBenchmark && f.name === selectedBenchmark.name
                    "
                  >
                    {{ f.name_full }}
                  </div>
                }
              </mat-nav-list>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-expansion-panel>
    }

    @if (commodities.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header (click)="$event.stopPropagation()">
          <mat-panel-title><b>Commodities</b></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          @for (f of commodities; track f) {
            <div
              mat-menu-item
              (click)="onBenchmarkSelect(f)"
              [class.active]="
                selectedBenchmark && f.name === selectedBenchmark.name
              "
            >
              {{ f.name_full }}
            </div>
          }
        </mat-nav-list>
      </mat-expansion-panel>
    }

    @if (currencies.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header (click)="$event.stopPropagation()">
          <mat-panel-title><b>Currencies</b></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list>
          @for (f of currencies; track f) {
            <div
              mat-menu-item
              (click)="onBenchmarkSelect(f)"
              [class.active]="
                selectedBenchmark && f.name === selectedBenchmark.name
              "
            >
              {{ f.name_full }}
            </div>
          }
        </mat-nav-list>
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-menu>
